import gql from 'graphql-tag'

import { Query } from '../types-graphql'
import { userFragment } from './fragments'

export type TDataUsers = Pick<Query, 'users' | '__typename'>
export const USERS = gql`
  query ($q: UserRansack, $areaId: ID, $page: Int, $perPage: Int) {
    users(q: $q, page: $page, perPage: $perPage, areaId: $areaId) {
      nodes {
        ...UserFragment
        coursesCount
        externalCoursesCount
        allCoursesProgress {
          finish
          inProgress
          pending
        }
        allCoursesProgressEvaluations {
          approved
          reproved
          total
        }
      }
      pagesCount
      nodesCount
      hasNextPage
      hasPreviousPage
    }
  }
  ${userFragment}
`

export type TDataUsersCount = Pick<Query, 'usersCount' | '__typename'>
export const USERS_COUNT = gql`
  query ($areaId: ID, $q: UserRansack) {
    usersCount(areaId: $areaId, q: $q)
  }
`
